import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHardHat, faBuilding, faHome, faWarehouse } from '@fortawesome/free-solid-svg-icons';
import './about.css'; // Import the CSS file
import img1 from "../../assets/about/about3.jpeg";  // Large Image

const AboutUs = () => {
  return (
    <div className="about-us-container">
      <div className="about-us-content">
        {/* Left Side */}
        <div className="left-side">
          <h3 >About Us </h3>
          <div className="underline"></div>
          <h4 style={{ textAlign:"center", color:"#FDC30B"}}>First Sky Infrastructure</h4>
          <p style={{ textAlign:"justify"}}>
            Welcome to First Sky Infrastructure, a trusted name in the construction
            and real estate industry. With 25 years of experience in the field, our company was officially
            established in 2012 to provide top-tier construction and real estate solutions.
          </p>
         
</div>


          {/* Right Side */}
          <div className="right-side">
            <div className="image-container">
              <img src={img1} alt="Construction Site" className="large-image" />
            </div>
          </div>
        </div>
      </div>
      );
};

      export default AboutUs;
